import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import {getModuleEnumByLabel} from "./constants/enums/moduleEnum"
import Layout from './components/Layout'
import EventService from './services/EventService'
import track, { useTracking } from 'react-tracking'
import { TRACKING } from 'utilities/constants'
import { useEffect, useState } from "react";
import LoginService from 'services/LoginService'
import LoginPage from 'pages/login/login'
import { useLocation } from 'react-router-dom';

const isAuth = window.localStorage.getItem('isAuthenticated')
const userModules = window.localStorage.getItem('modules')
const isActive = window.localStorage.getItem('isActive')
const token = window.localStorage.getItem('token')
const id = window.localStorage.getItem('id')

export const App = ({ component: Component, rest }) => {
    const [isValid, setIsValid] = useState(true);
	const location = useLocation();
    

	useEffect(() => {
		const timer = setTimeout(() => {
			getTokenValidation();
		  }, 1000);
	}, [location.pathname]);
	const getTokenValidation = (event) => {
			LoginService.validerJwt(token,id)
			.then((response) => {
				setIsValid(response.data);
			})
			.catch((error) => {
				setIsValid(false);
			});
	
	};	
    const { Track } = useTracking(
        { app: 'augmenticom-client' },
        {
            dispatch: (data) => {
                if(TRACKING.LOG){
                    if (data.status === undefined || data.status === '' || data.status === null) {
                        EventService.saveEvents({
                            app: data.app,
                            token: token,
                            funComponent: data.funComponent,
                            event: data.event,
                            status: '200'
                        })
                    } else {
                        EventService.saveEvents({
                            app: data.app,
                            token: token,
                            funComponent: data.funComponent,
                            event: data.event,
                            status: data.status
                        })
                    }
                }
            }
        }
    )
    return (
        <Track>
            <Route
                {...rest}
                render={(routeProps) => {
                    console.log('=== DEBUG APP.JS ===')
                    console.log('Component.name:', Component.name)
                    console.log('Component.displayName:', Component.displayName)
                    console.log('isAuth:', isAuth)
                    console.log('isValid:', isValid)
                    console.log('isActive:', isActive)
                    
                    let ModulesJSON = JSON.parse(userModules)
                    let modules = ''
                    
                    
                    if (ModulesJSON !== null) {
                        Object.keys(ModulesJSON).forEach((name) => {
                            let module = getModuleEnumByLabel(ModulesJSON[name].module.libelle)
                
                            if (module === 'Volumetrie' || module === 'KPI') module = 'Statistique'
                            if (module === 'Role' || module === 'Utilisateur') module = 'Parametre'
                            modules = modules + module + ','
                            let sousModules = ModulesJSON[name].sousModule
                            if (sousModules !== null) {
                                sousModules.forEach((sousModule) => {
                                    modules = modules + getModuleEnumByLabel(sousModule.libelle) + ','
                                })
                            }
                        })
                    }
                    modules = modules + 'Home,UserDetails,Documentation'
                    
                    // Utiliser le nom du composant (Component.name) pour la vérification des permissions
                    // Le displayName est juste pour l'affichage
                    const componentName = Component.name
                    const displayName = Component.displayName || Component.name
                    
                    // Si le composant est JournalChannelFile (Historique), vérifier l'accès au module Facture
                    const moduleToCheck = componentName === 'JournalChannelFile' ? 'Facture' : componentName
                    
                    console.log('Modules autorisés:', modules)
                    console.log('Nom composant:', componentName)
                    console.log('Nom affichage:', displayName)
                    console.log('Module vérifié:', moduleToCheck)
                    console.log('modules.includes(moduleToCheck):', modules.includes(moduleToCheck))
                    
                    if (isAuth && isValid) {
                        if (isActive === 'true') {
                            if (modules.includes(moduleToCheck)) {
                                console.log('✅ ACCÈS AUTORISÉ pour', componentName, '(affiché comme:', displayName + ') via module', moduleToCheck)
                                return (
                                    <Layout>
                                        <Component {...routeProps} />
                                    </Layout>
                                )
                            } else {
                                console.log('❌ ACCÈS REFUSÉ pour', componentName, '(affiché comme:', displayName + ') - Module', moduleToCheck, 'non autorisé - Redirection vers 404')
                                return <Redirect to="/404" />
                            }
                        } else {
                            console.log('⚠️ Utilisateur non actif - Redirection vers modifyPassword')
                            return <Redirect to="/modifyPassword" />
                        }
                    } else {
                        console.log('⚠️ Non authentifié ou token invalide - Redirection vers login')
                        return <LoginPage />
                    }
                }}
            />
        </Track>
    )
}
